import { FocusTrapZone, Layer, Overlay } from '@fluentui/react';
import { RequestDetailsPopUpStyle } from './styles/RequestDetailsPopUp.styled';
import { RequestDetailsContainer } from './requestDetailsContainer/RequestDetailsContainer';
import { RequestDetailsCancelPopup } from './requestDetailsCancelPopupContainer/RequestDetailsCancelPopup';
import { useGetRequestDetails } from './hooks/useGetRequestDetails';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import { VacationRequestType } from '../../../../tabs/hooks/useSummaryInfo';

interface RequestDetailsPopUpProps {
  hideRequestPopup: () => void;
  isRequestPopupVisible: boolean;
  isCancelPopupVisible: boolean;
  showCancelPopup: () => void;
  hideCancelPopup: () => void;
  requestId: string;
  vacationTypes: VacationType[];
  selectedYear: number;
  getSummary: (
    bonusDays?: number,
    paidDays?: number,
    requestType?: VacationRequestType
  ) => Promise<void>;
  getUserRequests: (
    statusCode?: string[],
    vacationTypeId?: string[],
    vacationTypes?: VacationType[]
  ) => Promise<void>;
  vacationType: string[];
  vacationStatus: string[];
}

export const RequestDetailsPopUp = ({
  hideRequestPopup,
  isRequestPopupVisible,
  hideCancelPopup,
  isCancelPopupVisible,
  showCancelPopup,
  requestId,
  vacationTypes,
  selectedYear,
  getSummary,
  getUserRequests,
  vacationType,
  vacationStatus,
}: RequestDetailsPopUpProps) => {
  const { requestDetails } = useGetRequestDetails(requestId, selectedYear);
  return (
    <>
      {isRequestPopupVisible && requestDetails && (
        <Layer>
          <RequestDetailsPopUpStyle
            role="dialog"
            aria-modal="true"
            onDismiss={hideRequestPopup}
          >
            <FocusTrapZone>
              <Overlay onClick={hideRequestPopup} />
              <RequestDetailsContainer
                hideRequestPopup={hideRequestPopup}
                showCancelPopup={showCancelPopup}
                requestDetails={requestDetails}
              />
              <RequestDetailsCancelPopup
                vacationTypes={vacationTypes}
                requestDetails={requestDetails}
                getSummary={getSummary}
                hideRequestPopup={hideRequestPopup}
                isCancelPopupVisible={isCancelPopupVisible}
                hideCancelPopup={hideCancelPopup}
                requestId={requestId}
                getUserRequests={getUserRequests}
                vacationType={vacationType}
                vacationStatus={vacationStatus}
              />
            </FocusTrapZone>
          </RequestDetailsPopUpStyle>
        </Layer>
      )}
    </>
  );
};
